export default __webpack_public_path__ + "f04c53ca99903d653b0a1c048d234cad.svg";